import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VehicleLicensePlatePage } from './vehicle-license-plate.page';

const routes: Routes = [
  {
    path: '',
    component: VehicleLicensePlatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehicleLicensePlatePageRoutingModule {}
